import styled from 'styled-components';
import { Text as BaseText } from '../../components';

export default styled(BaseText)`
  color: #333333;
`;
